import { ChangeDetectionStrategy, Component } from '@angular/core';

@Component({
    selector: 'app-arrow-up',
    templateUrl: './arrow-up.component.svg',
    styleUrls: ['./arrow-up.component.scss'],
    changeDetection: ChangeDetectionStrategy.OnPush,
})
export class ArrowUpComponent {}
